/* eslint-disable react/no-danger */
import {css, view, createView} from '@sail/ui';
import {renderMarkdown} from '../../helpers/markdown';
import {renderMarkdownSearchAI} from '../../helpers/markdownSearchAI';
import {secondaryLinkStyles} from '../../helpers/style-intents';

export const MarkdownText = createView(
  ({
    body,
    isSearchAI = false,
    ...props
  }: {
    body: string;
    /**
     * Is this component used within the Search AI experience?
     */
    isSearchAI?: boolean;
  }) => {
    // As of 08-20-2025, we maintain a separate markdown renderer for the search AI experience to de-risk changes that might otherwise affect the assistant.
    // For now, the search AI markdown renderer is just removing "mailto" links as its sole difference.
    // TODO(crob): Merge these two markdown renderers once we have alignment on what we want a unified version to do.
    const renderFn = isSearchAI ? renderMarkdownSearchAI : renderMarkdown;

    return (
      <view.div
        {...props}
        data-testid="markdown-text"
        className="uh-live-answers-v2-text-body"
        css={{
          stack: 'y',
          gap: 'medium',
          wordBreak: 'break-word',
        }}
        uses={[
          secondaryLinkStyles('.uh-live-answers-v2-text-body'),
          css.global({
            '.uh-live-answers-v2-text-body p': {
              marginY: 12,
            },
            '.uh-live-answers-v2-text-body p:first-of-type': {
              marginTop: 0,
            },
            '.uh-live-answers-v2-text-body p:last-of-type': {
              marginBottom: 0,
            },
            '.uh-live-answers-v2-text-body ol, .uh-live-answers-v2-text-body ul':
              {
                margin: 0,
                paddingLeft: 'medium',
              },
            '.uh-live-answers-v2-text-body li': {
              marginY: 12,
            },
            '.uh-live-answers-v2-text-body li:first-of-type': {
              marginTop: 0,
            },
            '.uh-live-answers-v2-text-body li:last-of-type': {
              marginBottom: 0,
            },
            '.uh-live-answers-v2-text-body li li:first-of-type, .uh-live-answers-v2-text-body li li:last-of-type':
              {
                marginY: 12,
              },

            '.uh-live-answers-v2-text-body li ol, .uh-live-answers-v2-text-body li ul':
              {
                marginLeft: 0,
              },
            '.uh-live-answers-v2-text-body li p': {
              marginY: 12,
            },
            '.uh-live-answers-v2-text-body li p:first-of-type, .uh-live-answers-v2-text-body li p:last-of-type':
              {
                marginY: 0,
              },
          }),
        ]}
        // nosemgrep: no-react-dangerouslysetinnerhtml
        dangerouslySetInnerHTML={{__html: renderFn(body)}} // eslint-disable-line react/no-danger
      />
    );
  },
);
